"use strict";
exports.__esModule = true;
var account_1 = require("../../account");
function getDeviceTransactionConfig(_a) {
    var account = _a.account, parentAccount = _a.parentAccount, _b = _a.transaction, mode = _b.mode, recipient = _b.recipient, _c = _a.status, amount = _c.amount, estimatedFees = _c.estimatedFees;
    var mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    var source = account.type === "ChildAccount"
        ? account.address
        : mainAccount.freshAddress;
    var isDelegateOperation = mode === "delegate";
    var fields = [
        {
            type: "address",
            label: "Source",
            address: source
        },
    ];
    if (isDelegateOperation) {
        fields.push({
            type: "tezos.delegateValidator",
            label: "Validator"
        }, {
            type: "address",
            label: "Delegate",
            address: recipient
        });
    }
    if (!amount.isZero()) {
        fields.push({
            type: "amount",
            label: "Amount"
        });
    }
    if (!estimatedFees.isZero()) {
        fields.push({
            type: "fees",
            label: "Fees"
        });
    }
    fields.push({
        type: "tezos.storageLimit",
        label: "Storage Limit"
    });
    return fields;
}
exports["default"] = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map